module.exports = __webpack_public_path__ + "prod/1.42.2/img/success_exam2.6da6ee85.png";